import React from 'react';

import { Button } from 'react-bootstrap';

export default function ErrorMessage({OnClick, fullPage}) {
    return (
        <div 
        className="text-center w-100 pt-4 pb-4 pl-5 pr-5" 
        style={fullPage && {height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}
        >
            <div>
                <svg height="60px" viewBox="0 0 24 24" width="60px"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/></svg>
            </div>
            <div className="mt-2">
                <span className="h6 font-weight-700">Algo ha salido mal, intentalo nuevamente</span>
                <p className="font-size-md mt-2 pl-5 pr-5">Ha ocurrido un error inésperado, puede deberse a un problema técnico de la plataforma que intentamos solventar, pruebe a intentarlo de nuevo.</p>
            </div>
            <div className="mt-3">
                <Button 
                variant="primary" 
                className="btn-rounded"
                style={{width: '200px'}}
                onClick={OnClick}
                >
                    Volver a intentar
                </Button>
            </div>
        </div>
    )
}
